import {
  getTrainerHoursStatusText,
  TrainerHoursStatusEnum,
} from './trainerHours';

export interface TrainerPayroll {
  year: number;
  month: number;
  trainerId: string; // Guid
  trainerFullName: string;
  courseId?: string; // Guid, optional
  courseName: string;
  departmentName: string;
  totalHours: number;
  feeTotalEuro: number;
  costCenter: string;
  status: TrainerHoursStatusEnum;
  exported: boolean;
}

export interface Value {
  value: TrainerPayroll[];
  '@odata.context'?: string | undefined;
  '@odata.count'?: number | undefined;
}

function toAPI(data: Partial<TrainerPayroll>): any {
  return {
    Status: data?.status ?? TrainerHoursStatusEnum.Open,
    Exported: data?.exported ?? false,
  };
}

function parse(data?: Partial<TrainerPayroll>): TrainerPayroll {
  const status =
    typeof data?.status === 'string'
      ? data.status
      : getTrainerHoursStatusText(data?.status ?? TrainerHoursStatusEnum.Open);

  return {
    year: data?.year || new Date().getUTCFullYear(),
    month: data?.month || 1,
    trainerId: data?.trainerId || '',
    trainerFullName: data?.trainerFullName || '',
    courseId: data?.courseId || undefined,
    courseName: data?.courseName || '',
    departmentName: data?.departmentName || '',
    totalHours: data?.totalHours || 0,
    feeTotalEuro: data?.feeTotalEuro || 0,
    costCenter: data?.costCenter || '',
    status:
      TrainerHoursStatusEnum[status as keyof typeof TrainerHoursStatusEnum],
    exported: data?.exported ?? false,
  };
}

export default {
  parse,
  toAPI,
};
